// external dependencies
import React from "react";
import { useNavigate } from "react-router-dom";

import Text from "../../../../../../components/Text";
// components
import { CardBody, CardHeader } from "../../../../components/Card";
import TopCohortsChart from "./TopCohortsChart";

// Config
import Config from "../../../../Config";
// styles
import css from "./TopCohorts.module.scss";

const TopCohorts = () => {
	const navigate = useNavigate();
	return (
		<>
			<CardHeader
				title={
					<Text element="span" size="paragraph-2" weight="semi-bold">
						Top Cohorts
					</Text>
				}
				info="The most satisfied cohorts for the selected period."
				options={[
					{
						id: "view-cohorts",
						label: "Cohorts",
						action: () => {
							// navigate to /engagement/factors page
							navigate(Config.ROUTES.COHORTS.url);
						},
					},
				]}
			/>
			<CardBody>
				<div className={css.cardBody}>
					<div className={css.cohortsChart}>
						<TopCohortsChart />
					</div>
				</div>
			</CardBody>
		</>
	);
};

export default TopCohorts;
